<template>
    <div class="cv-manager-schema-list-container">
        <div class="cv-manager-schema-list-header sticky-top">
            <div class="cv-manager-schema-list-title font-6">Conversion Value Maps</div>
            <button id="plusButton" @click="$emit('addNew')" v-if="!viewOnly && !testerUser">
                <IconBase verticalAlign="middle"
                          iconName="plusBoldIcon"
                          :width="9"
                          :height="9"
                          :iconColor="consts.COLORS.DARK_500"
                          class="button-icon"/>
            </button>
        </div>
        <div class="cv-manager-schema-list-content sticky-top">
            <ul>
                <li :class="{'selected': selectedId && schema.id == selectedId}"
                    class="font-6 cv-manager-schema-list-item truncate"
                    v-for="schema in schemas"
                    :key="schema.id"
                    @click="schemaSelected(schema)">
                    <Tooltip :text="schema.name" class="truncate">
                        {{schema.name}}
                    </Tooltip>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import IconBase from 'components/IconBase.vue';
import consts from 'services/metaData/consts';
import Tooltip from 'components/Tooltip/Tooltip.vue';

export default {
    name: 'CVSchemaList',
    components: { IconBase, Tooltip },
    props: {
        schemas: {
            type: Array,
            required: true
        },
        selectedId: String,
        viewOnly: {
            type: Boolean,
            default: true
        },
        testerUser: {
            type: Boolean,
            default: true
        }
    },
    data: () => ({
        consts
    }),
    methods: {
        schemaSelected(schema) {
            // eslint-disable-next-line eqeqeq
            if (schema.id != this.selectedId) {
                this.$emit('update:selected', schema.id);
            }
        }
    }
};
</script>

<style scoped lang="scss">
@import "~styles/styleGuide";
$rowHeight: 48px;
$plusButtonSize: 24px;

ul {
    list-style-type: none;
    margin: 0;
    padding: 0;
}

.sticky-top {
    top: 0px;
    position: sticky;
    z-index: 1;
}

#plusButton {
    background-color: $light-500;
    border-radius: 100%;
    border: none;
    height: $plusButtonSize;
    width: $plusButtonSize;
    outline: none;
    cursor: pointer;
    min-width: initial;
    background-image: initial;
    padding: initial;

    .button-icon {
        margin-bottom: 2px;
    }

    &:hover {
        background-color: $light-600;
    }
}

.cv-manager-schema-list-container {
    height: 100%;
    position: relative;

    .cv-manager-schema-list-content {
        height: 90%;
        overflow-y: auto;
        padding-bottom: 24px;
    }

    .cv-manager-schema-list-header {
        padding: 12px 0;
        display: flex;
        justify-content: space-between;
        color: $light-900;
        background-color: $light-200;

        .cv-manager-schema-list-title{
            line-height: 2;
        }
    }

    .cv-manager-schema-list-item {
        text-decoration: none;
        height: $rowHeight;
        color: $dark-300;
        padding: 15px 16px;
        display: block;
        line-height: 1.5;

        span {
            display: block;
        }

        &.selected, &:hover {
            border-radius: 100px;
        }

        &.selected {
            background-color: $white;
        }

        &:hover {
            cursor: pointer;
            background-color: $light-300;

            &.selected {
                background-color: $white;
            }
        }
    }
}


</style>
